import { useAxios } from 'hooks/useAxios';
import { AxiosErrorHandler } from 'shared/Helpers';
import { BASE_URL_V2 } from 'shared/constants';

export const useUtilsApi = () => {
  const { axios } = useAxios(BASE_URL_V2);

  /**
   * Converts HTML content to PDF
   * @param {string} html - The HTML content to convert to PDF
   * @param {string} supplierName - The name of the supplier
   * @param {string} reportType - The type of report being generated
   * @returns {Promise<Blob>} A promise that resolves to the PDF blob
   */
  const htmlToPdf = async (html: string, supplierName: string, reportType: string): Promise<Blob> => {
    try {
      const res = await axios.post('/utils/html-to-pdf', { html, supplierName, reportType }, { responseType: 'blob' });
      return res.data;
    } catch (e) {
      AxiosErrorHandler(e);
      throw e;
    }
  };

  return {
    htmlToPdf
  };
};
